document.documentElement.classList.add('js');
const initNTXA=()=>{
  document.querySelectorAll('details').forEach((detail)=>detail.addEventListener('toggle',()=>{
    const icon=detail.querySelector('summary span:last-child'); if(icon) icon.textContent=detail.open?'−':'+';
  }));
  document.querySelectorAll('[data-bundle-picker]').forEach((picker)=>{
    const form=picker.closest('form');
    const total=form?.querySelector('[data-bundle-total]');
    const oneTimePrice=form?.querySelector('[data-one-time-price]');
    const subscriptionPrice=form?.querySelector('[data-subscription-price]');
    const subscriptionNote=form?.querySelector('[data-subscription-note]');
    const sellingPlanInputs=[...(form?.querySelectorAll('[data-selling-plan-input]')||[])];
    const subscriptionRadio=form?.querySelector('input[name="purchase_mode"][value="subscription"]');
    const oneTimeRadio=form?.querySelector('input[name="purchase_mode"][value="one_time"]');
    const syncPurchaseOption=(input)=>{
      const planId=input.dataset.sellingPlanId||'';
      const planPrice=input.dataset.sellingPlanPrice||'';
      const planNote=input.dataset.sellingPlanNote||subscriptionNote?.dataset.defaultText||'';
      if(oneTimePrice) oneTimePrice.textContent=input.dataset.price||'';
      if(subscriptionPrice) subscriptionPrice.textContent=planPrice||'Unavailable';
      if(subscriptionNote) subscriptionNote.textContent=planNote;
      
      if(subscriptionRadio) subscriptionRadio.disabled=!planId;
      if(!planId&&subscriptionRadio?.checked) oneTimeRadio?.click();
      const subscriptionSelected=subscriptionRadio?.checked&&planId;
      const applySellingPlan=()=>{
        sellingPlanInputs.forEach((sellingPlanInput)=>{
          const selected=Boolean(subscriptionSelected&&sellingPlanInput.value===planId);
          sellingPlanInput.checked=selected;
          sellingPlanInput.disabled=!selected;
        });
      };
      applySellingPlan();
      window.setTimeout(applySellingPlan,0);
      if(total) total.textContent=subscriptionSelected?planPrice:(input.dataset.price||'');
      picker.querySelectorAll('input[name="id"]').forEach((bundleInput)=>{
        const card=bundleInput.closest('.bundle-card');
        const perBottle=card?.querySelector('[data-card-per-bottle]');
        const cardTotal=card?.querySelector('[data-card-total]');
        const usePlan=subscriptionRadio?.checked&&bundleInput.dataset.sellingPlanId;
        if(perBottle) perBottle.textContent=usePlan?(bundleInput.dataset.sellingPlanPerBottlePrice||bundleInput.dataset.perBottlePrice):(bundleInput.dataset.perBottlePrice||'');
        if(cardTotal) cardTotal.textContent=usePlan?(bundleInput.dataset.sellingPlanPrice||bundleInput.dataset.price):(bundleInput.dataset.price||'');
      });
    };
    picker.querySelectorAll('input[type="radio"]').forEach((input)=>input.addEventListener('change',()=>syncPurchaseOption(input)));
    form?.querySelectorAll('input[name="purchase_mode"]').forEach((input)=>input.addEventListener('change',()=>{
      const selectedBundle=picker.querySelector('input[name="id"]:checked');
      if(selectedBundle) syncPurchaseOption(selectedBundle);
    }));
    form?.addEventListener('formdata',(event)=>{
      const selectedBundle=picker.querySelector('input[name="id"]:checked');
      const planId=selectedBundle?.dataset.sellingPlanId||'';
      if(subscriptionRadio?.checked&&planId) event.formData.set('selling_plan',planId);
      else event.formData.delete('selling_plan');
    });
    const selectedBundle=picker.querySelector('input[name="id"]:checked');
    if(selectedBundle) syncPurchaseOption(selectedBundle);
  });
};
if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',initNTXA,{once:true});
else initNTXA();